import React from 'react'
import GridBlock from "components/GridBlock";
import PropTypes from "prop-types";
import DateTimePicker from "components/DateTimePicker";
import Tr from "translations/Translations";
import {makeStyles} from "@material-ui/styles";
import BoldTypography from "components/BoldTypography";

const useStyle = makeStyles(theme => ({
    root: {},
    picker: {
        width: 400,
        marginRight: theme.spacing(3)
    },
    stageHead: {
        marginTop: theme.spacing(4)
    }
}))

function PurchasingGroupStage2ScheduleForm(
    {
        formikProps,
        schedule,
        editable
    }) {
    const classes = useStyle();

    return (<GridBlock
        column
    >

        <BoldTypography>{Tr('purchasing_group_opinion_swz_stage')}</BoldTypography>
        <GridBlock>
            <DateTimePicker
                className={classes.picker}
                formikProps={formikProps}
                id="swzOpinionStartDate"
                label={Tr('purchase_group_stage_start_date')}
                required={schedule.swzOpinionStartDateEditable}
                disabled={!editable || !schedule.swzOpinionStartDateEditable}
            />
            <DateTimePicker
                className={classes.picker}
                formikProps={formikProps}
                id="swzOpinionEndDate"
                label={Tr('purchase_group_stage_end_date')}
                required={schedule.swzOpinionEndDateEditable}
                disabled={!editable || !schedule.swzOpinionEndDateEditable}
            />
        </GridBlock>

        <BoldTypography className={classes.stageHead}>{Tr('purchasing_group_collecting_data_stage')}</BoldTypography>
        <GridBlock>
            <DateTimePicker
                className={classes.picker}
                formikProps={formikProps}
                id="collectingDataStartDate"
                label={Tr('purchase_group_stage_start_date')}
                required={schedule.collectingDataStartDateEditable}
                disabled={!editable || !schedule.collectingDataStartDateEditable}
            />
            <DateTimePicker
                className={classes.picker}
                formikProps={formikProps}
                id="collectingDataEndDate"
                label={Tr('purchase_group_stage_end_date')}
                required={schedule.collectingDataEndDateEditable}
                disabled={!editable || !schedule.collectingDataEndDateEditable}
            />
        </GridBlock>

    </GridBlock>)
}

PurchasingGroupStage2ScheduleForm.propTypes = {
    schedule: PropTypes.shape({
        swzOpinionStartDateEditable: PropTypes.bool.isRequired,
        swzOpinionEndDateEditable: PropTypes.bool.isRequired,
        collectingDataStartDateEditable: PropTypes.bool.isRequired,
        collectingDataEndDateEditable: PropTypes.bool.isRequired,
    }).isRequired
}

export default PurchasingGroupStage2ScheduleForm;